import { request } from '@/utils/request'

/**
 * 获取角色枚举
 */
export function getEnum(className) {
  return request({
    url: `enum/${className}`,
    method: 'get',
    data: {}
  })
}
//查询模板
export function templateGetting(id) {
  return request({
    url: `/exam-setting/exam/${id}`,
    method: 'get'
  })
}
//考生详情信息
export function getUserDetail(userId) {
  return request({
    url: `examUser/${userId}`,
    method: 'get'
  })
}

// /schoolNotice/NoReadCount 未读总数
export function noReadCount() {
  return request({
    url: `schoolNotice/NoReadCount`,
    method: 'post'
  })
}

// /schoolNotice/getUserList 获取用户的消息列表
export function getUserList(params) {
  return request({
    url: `schoolNotice/getUserList`,
    method: 'post',
    data: params
  })
}

// schoolNoticeuser/save 已读
// {"id": 0,"noticeid": 0,"userid": 0}
export function schoolNoticeuser(params) {
  return request({
    url: `schoolNoticeuser/save`,
    method: 'post',
    data: params
  })
}

// uploadPayImage
export function uploadPayImage(params) {
  return request({
    url: `examUser/uploadPayImage`,
    method: 'post',
    data: params
  })
}
export function uploadImage(file) {
  return request({
    url: `/file/upload/image`,
    method: 'post',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
